/**
 * Directiva para utilizar el buttonset de jquery
 * @example
 *      <sigo-buttonset
 ng-model="modelo"
 items="listaValores"
 label="nombre"
 value="id"
 id="unaid"
 </sigo-buttonset>
 */
buttonsetDirective.$inject = ['$timeout'];
export default function buttonsetDirective($timeout) {
    return {
        restrict: 'E',
        require: 'ngModel',
        transclude: true,
        scope: {
            'items': '=',
            'value': '@',
            'label': '@',
            'id': '@',
            'ngDisabled': '=',
            'ngChange': '&'
        },
        template: require('./buttonsetView.html'),
        link: function (scope, element, attrs, ngModelCtrl) {
            element.hide();
            scope.modelo = {};
            $(function () {
                //TODO: validar
                //TODO: mirar de quitar id
                if (typeof scope.items === 'undefined')
                    throw new Exception('La variable items es obligatoria');
                scope.value = typeof scope.value !== 'undefined' ? scope.value : 'value';
                scope.label = typeof scope.label !== 'undefined' ? scope.label : 'label';
                scope.id = typeof scope.id !== 'undefined' ? scope.id : attrs.ngModel;
                scope.$evalAsync(function () {
                    $timeout(function () {
                        element.buttonset();
                        element.show();
                        element.find('input[type=radio]').change(function () {
                            var valor = element.find('input[type=radio]:checked').val();
                            ngModelCtrl.$setViewValue(valor);
                        });

                        scope.$watch('ngDisabled', function (newValue, oldValue) {
                            $timeout(function () {
                                element.buttonset("refresh");
                            });
                        });
                        var model2view = function () {
                            //Actualizamos el selectmenu cuando se actualiza el modelo
                            var valorSeleccionado = ngModelCtrl.$viewValue;
                            var elOpcion = element.find('input[type=radio][value=' + valorSeleccionado + ']');
                            elOpcion.prop('checked', true);

                            element.buttonset("refresh");
                        };

                        ngModelCtrl.$render = model2view;

                        model2view();
                    });
                });
            });
        }
    }
}